import React, { useState } from 'react';
import { ChatList } from '../components/ChatList';
import { ChatConversation } from '../components/ChatConversation';
import { useSupportChats } from '../hooks/useSupportChats';
import { useSupportActions } from '../hooks/useSupportActions';
import { ChatStatus } from '../models/support';
import './SupportScreen.css';

export const SupportScreen: React.FC = () => {
    const { chats, connected, updateChat } = useSupportChats();
    const { sendMessage, changeStatus, sending } = useSupportActions();
    const [selectedTgId, setSelectedTgId] = useState<string | null>(null);
    const [statusFilter, setStatusFilter] = useState<ChatStatus | 'ALL'>('ALL');

    const selectedChat = chats.find(c => c.tgId === selectedTgId) ?? null;

    const handleSendMessage = (tgId: string, text: string, file: File | null) => {
        sendMessage(tgId, text, file, updateChat);
    };

    const handleChangeStatus = (tgId: string, status: ChatStatus) => {
        changeStatus(tgId, status, updateChat);
    };

    return (
        <div className="support-screen">
            {connected === 'disconnected' && (
                <div className="support-screen__offline-banner">
                    Нет соединения — данные могут быть устаревшими
                </div>
            )}
            <div className="support-screen__body">
                <div className="support-screen__list">
                    <ChatList
                        chats={chats}
                        selectedTgId={selectedTgId}
                        statusFilter={statusFilter}
                        onSelect={setSelectedTgId}
                        onFilterChange={setStatusFilter}
                    />
                </div>
                <div className="support-screen__conv">
                    <ChatConversation
                        chat={selectedChat}
                        sending={sending}
                        onSendMessage={handleSendMessage}
                        onChangeStatus={handleChangeStatus}
                    />
                </div>
            </div>
        </div>
    );
};
